import PropTypes from "prop-types"
import React, { useEffect } from "react"
import { connect } from "react-redux"
import { Redirect, withRouter } from "react-router-dom"

import { logoutUser } from "../../store/actions"

//redux
import { useSelector, useDispatch } from "react-redux"

const Logout = props => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(logoutUser(history))
  }, [])

  return <Redirect to="/login" />
}

Logout.propTypes = {
  history: PropTypes.object,
}

export default withRouter(Logout)
